module.exports = __webpack_public_path__ + "packs/media/images/crowdfunding/falesia10-a8520a911f3a12a9928e17919f856df3.jpg";